export const DefaultItemWidthDesktop = 202;
export const DefaultItemWidthMobile = 100 + 20;
export const DefaultItemWidthMobileMiddle = 100 + 30;
export const MaxCarouselWidth = 988;
export const MaxItems = 4;
